export default __webpack_public_path__ + "static/media/DownArrow.9c7260ee.svg";